import { combineReducers } from 'redux';
import { suggestions, searchQuery } from './components/autoSuggest/autoSuggestReducer';

export default combineReducers({
  suggestions,
  searchQuery,
});
